// src/pages/InstallationStatus/components/NewStatus.jsx
import React, { useEffect, useState, useCallback } from "react";
import { Table, Pagination } from "antd";
import { fetchStatuses } from "../utils/fetch";
import {
  getOrderStatusDataSource,
  orderStatusColumnsNew,
} from "../utils/table";
import OrderStatusFullInfo from "./OrderStatusFullInfo";

const NewStatus = ({ userPermission, query = "" }) => {
  const [leads, setLeads] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  // пагинация
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(20);
  const [totalCount, setTotalCount] = useState(0);

  // загрузка страницы
  const loadData = useCallback(
    (page = 1, size = limit) => {
      fetchStatuses(
        "ACTIVE",
        [
          "LOOP_MILLING",
          "READY_FOR_SHIPMENT",
          "ON_DELIVERY",
          "ORDER_DELIVERED",
          "PASSED_TO_MONTAGE",
        ],
        query,
        setLeads,
        setIsLoading,
        setTotalCount,
        page,
        size
      ).then(({ currentPage: cp }) => {
        setCurrentPage(cp);
        setLimit(size);
      });
    },
    [query, limit]
  );

  // при монтировании и при изменении query — сброс на 1-ю страницу
  useEffect(() => {
    loadData(1, limit);
  }, [query, loadData, limit]);

  // переключатель
  const handlePageChange = (page, size) => {
    loadData(page, size);
  };

  return (
    <div>
      <Table
        style={{ minWidth: 1000 }}
        size="small"
        bordered
        loading={isLoading}
        columns={orderStatusColumnsNew}
        dataSource={getOrderStatusDataSource(leads, loadData)}
        pagination={false}
        scroll={{ y: 500 }}
        expandable={{
          expandedRowRender: (record) => (
            <OrderStatusFullInfo
              data={record.data}
              userPermission={userPermission}
            />
          ),
        }}
      />

      <div style={{ marginTop: 16, textAlign: "center" }}>
        <Pagination
          current={currentPage}
          total={totalCount}
          pageSize={limit}
          showSizeChanger
          onChange={handlePageChange}
          onShowSizeChange={handlePageChange}
        />
      </div>
    </div>
  );
};

export default NewStatus;
